import { _defineProperty } from "@slyte/core/src/lyte-utils";
import { Route } from "../../../node_modules/@slyte/router/index.js";
let RadioComp;

class Radio extends Route {
  render() {
    return { outlet: '#zcatcomponent', component: RadioComp };
  }

  static actions(arg1) {
    return Object.assign(super.actions({}), arg1);
  }

  _() {
    _;
  }

  getRequirements() {
    arguments[1].push(
      import(/* webpackChunkName: "components/javascript/zcat-components/radio-comp" */
      "../../../components/javascript/zcat-components/radio-comp").then(function(res) {
        RadioComp = res.RadioComp;
      })
    );

    
;
  }
}

export { Radio };
